import { store } from 'store';
import { setHoveredId } from 'store/mapSlice';

import { InteractionTypeEnum, MapModeEnum } from 'enums';

import { MapBrowserEvent } from 'ol';
import Map from 'ol/Map';

import {
  activeSymbolerLayer,
  activeYtaLayer,
  drawVectorLayer,
  drawVectorSource,
  getPointFromActiveLayerAtPixel,
  publiceradeAktiviteterSymbolerWMTS,
  publiceradeBebyggelseobjektSymbolerWMTS
} from './Layers';

export const handlePointerMove = async (event: MapBrowserEvent<MouseEvent>, map: Map | undefined) => {
  let cursor = '';
  const mapMode = store.getState().map.mapMode;

  if (map && mapMode === MapModeEnum.EDIT_GEOMETRY) {
    const activeInteractions = store.getState().map.activeInteractions;
    if (activeInteractions.includes(InteractionTypeEnum.MODIFY_DELETE)) {
      if (drawVectorSource.getFeatures().length) {
        const features = await drawVectorLayer.getFeatures(event.pixel);
        cursor = features.length ? 'pointer' : '';
      }
    }
    if (activeInteractions.includes(InteractionTypeEnum.MODIFY)) {
      if (drawVectorSource.getFeatures().length) {
        const features = await drawVectorLayer.getFeatures(event.pixel);
        cursor = features.length === 0 ? 'copy' : '';
      }
    }
  }

  if (
    mapMode === MapModeEnum.INVENTERING_REGISTRATION ||
    mapMode === MapModeEnum.INVENTERING_PRESENTATION ||
    mapMode === MapModeEnum.ACTIVE_LAYERS_ONLY ||
    mapMode === MapModeEnum.SAMMANSATT_UTKAST_PRESENTATION ||
    mapMode === MapModeEnum.ADD_UTKAST_TO_SAMMANSATT ||
    mapMode === MapModeEnum.SEARCH
  ) {
    const previouslyHoveredId = store.getState().map.hoveredId;
    const activeFeatureProperties = await getPointFromActiveLayerAtPixel(event.pixel);

    let currentlyHoveredUtkastId = null;

    if (activeFeatureProperties.length) {
      currentlyHoveredUtkastId = activeFeatureProperties[0].id;
    }
    if (map) {
      cursor = currentlyHoveredUtkastId ? 'pointer' : '';
    }

    if ((previouslyHoveredId || currentlyHoveredUtkastId) && previouslyHoveredId !== currentlyHoveredUtkastId) {
      store.dispatch(setHoveredId(currentlyHoveredUtkastId ? currentlyHoveredUtkastId : ''));
      activeSymbolerLayer.changed();
      activeYtaLayer.changed();
    }
  }

  const wmsBebyggelseSymbolerRGBA = publiceradeBebyggelseobjektSymbolerWMTS.getData(event.pixel) as Uint8ClampedArray;
  const wmsBebyggelseSymbolerHit = wmsBebyggelseSymbolerRGBA && wmsBebyggelseSymbolerRGBA[3] > 0;
  const wmsInventeringsomradenSymbolerRGBA = publiceradeAktiviteterSymbolerWMTS.getData(
    event.pixel
  ) as Uint8ClampedArray;

  const wmsInventeringsomradenSymbolerHit =
    wmsInventeringsomradenSymbolerRGBA && wmsInventeringsomradenSymbolerRGBA[3] > 0;

  if (map && (wmsBebyggelseSymbolerHit || wmsInventeringsomradenSymbolerHit)) {
    cursor = 'pointer';
  }

  if (map) {
    map.getViewport().style.cursor = cursor;
  }
};
